/**
 * Turns polygon rings into one-pass line work. Adjacent ZCTA polygons often
 * repeat an edge in reverse order; Mapbox and SVG both render that as a dark
 * doubled seam when every polygon is stroked independently.
 */
export type GeoPoint = [number, number];
export interface BoundarySegment {
  key: string;
  start: GeoPoint;
  end: GeoPoint;
}

export function uniqueBoundarySegments(rings: GeoPoint[][]): BoundarySegment[] {
  const segments = new Map<string, BoundarySegment>();
  const pointKey = ([lng, lat]: GeoPoint) => `${lng.toFixed(6)},${lat.toFixed(6)}`;

  for (const ring of rings) {
    for (let index = 0; index < ring.length; index += 1) {
      const start = ring[index];
      const end = ring[(index + 1) % ring.length];
      if (!start || !end) continue;
      const startKey = pointKey(start);
      const endKey = pointKey(end);
      if (startKey === endKey) continue;
      const key = startKey < endKey ? `${startKey}|${endKey}` : `${endKey}|${startKey}`;
      if (!segments.has(key)) segments.set(key, { key, start, end });
    }
  }
  return [...segments.values()];
}
